// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".task-destination[data-v-7ca83f68]{--label-font-weight:500;--input-font-size:14px}.task-destination[data-v-7ca83f68] .form-group label{font-weight:var(--label-font-weight)}.task-destination[data-v-7ca83f68] .form-control{font-size:var(--input-font-size)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
